<template>
  <section>
    <span class="section-title">About Me</span>
    <div class="intro-section">
      <p>
        Hi! I'm
        <span class="brand-name" style="font-size: 1.5rem; color: var(--text-heading)">
          {{ content.name }}
        </span>.
        {{ content.about.intro }}
        Currently Working in
        <a :href="content.about.currentWork.url" target="_blank" class="inline-link">
          {{ content.about.currentWork.text }}
          <ExternalLink :size="15" stroke-width="1.8" />
        </a>

        <br>

        {{ content.about.bio }}
        If you want to trade
        <template v-for="(interest, i) in content.about.interests" :key="i">
          <span class="highlight">{{ interest }}</span><template v-if="i < content.about.interests.length - 1">, </template>
        </template>
        (or just say hi),
        you can find my <strong>Instagram</strong>, <strong>Email</strong> and <strong>LinkedIn</strong>
        links in the top right corner.
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { content } from "@/content/data";
import { ExternalLink } from "lucide-vue-next";
</script>

<style scoped>
.intro-section {
  max-width: 1000px;
  line-height: 1.8;
  font-size: 1.15rem;
  color: var(--text-muted);
  text-align: justify;
  hyphens: auto;
  text-align-last: left;
  padding-left: 1.8rem;
}
</style>
